import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApiService } from 'app/main/services/Api/api.service';
import { CoreMenuItem } from '@core/types';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent implements OnInit {
  @Input() item: CoreMenuItem;
  totalOrganizersOrders: number = 0;

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.item.title == 'طلبات المشرفين') {
      this.getTotalOrganizersOrders(); // Removed setTimeout (not needed)
    }
  }

  getTotalOrganizersOrders() {
    this.apiService.showAllOrganizerOrders(1, 100).subscribe({
      next: (response) => {
        console.log(response.data);
        this.totalOrganizersOrders = response.data ? response.data.length : 0;
        this.cdr.detectChanges(); // Manually trigger change detection
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }
}